import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import ResourcesService from '@/core/services/resources.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditResourcesComponent extends Vue {

  resourcesService: any = new ResourcesService();
  sidebarService: any = new SidebarService();
  logInModal: boolean = false;
  showModal: boolean = false;
  genericErr: any = [];
  sectionList: any = [];
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  resourcesList: any = [];
  section: string = "";
  name: string = "";
  title: string = "";
  type: string = "";
  archive: string = "";

  mounted (){
    const _ = this;
    _.getSection();
    _.getById();
    _.changeResources();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getSection(){
    const _ = this;
    _.isLoading = true;
    _.resourcesService.getSection().then((data: any) => {
      _.sectionList = data['data'].sections;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      _.isLoading = false;
    })
  }

  edit(){
    const _ = this;
    let resource = _.file;
    let resourceId: any = location.href.split("/");
    resourceId = resourceId[5];
    _.isLoading = true;
    _.resourcesService.edit(resource, resourceId).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/resource');
      }, 2000)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  getById(){
    const _ = this;
    let resourceId: any = location.href.split("/");
    resourceId = resourceId[5];
    _.isLoading = true;
    _.resourcesService.getById(resourceId).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].resource.name;
      _.type = data["data"].resource.type;
      _.title = data["data"].resource.sections[0].title;
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  changeResources(){
    const _ = this;
    _.archive = new FormData();
    _.archive.append('name', _.name);
    _.archive.append('type', _.type);
    _.archive.append('archive', document.querySelector('.archive').files[0]);
    for (var p of _.archive) {
      console.log(p);
    }
  }

  validations(name = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("por favor introduce un nombre");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
